/*
 * Copyright (c) 2020 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.common.properties

import com.macrofocus.common.annotation.JsExportClass

@JsExportClass
data class PropertyEvent<T>(val oldValue: T, val newValue: T) {
    override fun toString(): String {
        return "PropertyEvent{" +
                "oldValue=" + oldValue +
                ", newValue=" + newValue +
                '}'
    }

}